import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { SITE_URL } from '@/lib/seo';

/**
 * Visible breadcrumb trail + matching BreadcrumbList JSON-LD.
 * items: [{ name, to }] — the last item is the current page (no link).
 */
export const Breadcrumbs = ({ items = [] }) => {
  const trail = [{ name: 'Home', to: '/' }, ...items];
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: trail.map((t, i) => {
      const el = { '@type': 'ListItem', position: i + 1, name: t.name };
      // The final crumb (the current page) intentionally carries no item URL.
      if (t.to) el.item = `${SITE_URL}${t.to}`;
      return el;
    }),
  };

  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="mb-6">
      <ol className="flex flex-wrap items-center gap-1.5 text-xs font-['Outfit'] text-[#1C1917]/55">
        {trail.map((t, i) => {
          const last = i === trail.length - 1;
          return (
            <li key={t.name} className="flex items-center gap-1.5">
              {i > 0 && <ChevronRight className="w-3 h-3 opacity-50" aria-hidden="true" />}
              {last || !t.to ? (
                <span aria-current="page" className="text-[#1C1917]/80">{t.name}</span>
              ) : (
                <Link to={t.to} className="hover:text-[#F97316] transition-colors">{t.name}</Link>
              )}
            </li>
          );
        })}
      </ol>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
    </nav>
  );
};
